import { SEVERITY_COLORS } from '@root/utilities/pastelColors';
import '@root/pages/inventory1.3/charts/charts.scss';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

// const data = {
//   trend_data: [
//     {
//       scan_date: '2023-08-17T10:23:05',
//       total_score: 6.4,
//       new_score: 1,
//       critical_score: 2,
//       resolved_scire: 4,
//     },
//     {
//       scan_date: '2023-08-17T09:26:14',
//       total_score: 4.5,
//       new_score: 1,
//       critical_score: 2,
//       resolved_scire: 2.5,
//     },
//   ],
//   // ... other data ...
// };

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const { unique_cves, date } = payload[0].payload;

    return (
      <div className="custom_tooltip" style={{ outline: 0 }}>
        <p className="custom_tooltip_count m-0 p-0">{date}</p>
        <div className="count_container">
          <p
            className="custom_tooltip_severity m-0"
            style={{ borderLeft: `4px solid ${SEVERITY_COLORS.info}`, paddingLeft: '4px', borderRadius: '1px' }}>
            Unique CVEs: <span className="custom_tooltip_count"> {unique_cves ? unique_cves : '0'}</span>
          </p>
        </div>
      </div>
    );
  }
  return null;
};

const RiskTrendChart = ({ ChartData }) => {
  // useEffect(() => {
  //   if (data?.trend_data?.length === 1) {
  //     data?.trend_data?.push({
  //       ...data?.trend_data[0],
  //       scan_date: moment().format(),
  //     });
  //   }
  //   // console.log('riskTrendModifiedData', data);
  // }, [data]);

  return (
    <ResponsiveContainer width="100%" height={270} className="resource_charts" id="linechart_overview_new">
      <LineChart data={ChartData}>
        <XAxis dataKey="date" />
        <YAxis domain={[0, 'auto']} interval={0} />
        <Tooltip content={<CustomTooltip />} />

        <Line type="monotone" dataKey="unique_cves" stroke={SEVERITY_COLORS.info} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RiskTrendChart;
